<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("profile/SELECT_PROVIDER", this.$route.params.id);
    this.$router.back();
  },
};
</script>
